import { graphdata } from '../typing/typing';
import { Component } from 'react';
import { Column} from '@ant-design/charts';
import { Card, Skeleton } from 'antd';
import { cardmargin, grayheader } from '../../CSSReferences';

export interface GraphThingyMainProps{
  view:{
      loaded: boolean,
      autorefresh: boolean,
  },
  config : {
    data: graphdata[],
    xField: string,
    yField: string,
    label: {
      position: any,
      style: {
        fill: string,
        opacity: number,
      },
    },
    xAxis: {
      label: {
        autoHide: boolean,
        autoRotate: boolean,
      },
    },
    meta: {
      severity: { alias: string },
      count: { alias: string },
    },
}
  onLoadRequested:()=>void;
}

interface GraphThinyViewInnerState{}

export class GraphThingyView extends Component<GraphThingyMainProps, GraphThinyViewInnerState> 
{
    constructor(props:GraphThingyMainProps){
      super(props);
      this.state = {
          
      };
    }

    config = {
      data: this.props.config.data,
      xField: 'severity',
      yField: 'count',
       label: {
         style: {
           fill: '#0000FF',
           opacity: 0.6,
         },
       },
       yAxis:{
        title: {
          text: "Count",
          style: {
              fill: "#6E759F",
              fontSize: 14
          },
        },
      },
      xAxis: {
        label: {
        autoHide: false,
        autoRotate: false,
        style: {
          
        },
        offset: 10,
      },
        title: {
          text: "Severity",
          style: {
              fill: "#6E759F",
              fontSize: 14
          },
      }
      },
      meta: {
        severity: { alias: 'severity', values:["0","1","2","3","4","5","6","7","8","9","10"] },
        count: { alias: 'count' },
      },
      
    };

    // this.props.data;
    
    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 380);
      
      // this.props.onButtonClicked();
    };

  

  render(){
    if (this.props.view.loaded === false)
    {
      return (
        <div>
          <Card title="Vulnerabilities" style={cardmargin}  hoverable styles={{ header: grayheader }}>
          <Skeleton active />
          </Card>
          </div>
      )    
    }
    else
    {

    return (
      <Card title="Vulnerabilities" style={cardmargin}  hoverable styles={{ header: grayheader }}>
      <Column {...this.props.config} />
      </Card>
    )
  }
}
}
